import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicPage from "@/pages/PublicPage";
import SystemShell from "@/pages/SystemShell";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Clients from "@/pages/Clients";
import DocList from "@/pages/DocList";
import DocEditor from "@/pages/DocEditor";
import DocView from "@/pages/DocView";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicPage />} />
        {/* La primera parte de la URL debe coincidir con la ruta secreta configurada */}
        <Route path="/:slug" element={<SystemShell />}>
          <Route index element={<Dashboard />} />
          <Route path="inventario" element={<Inventory />} />
          <Route path="clientes" element={<Clients />} />
          <Route path="proformas" element={<DocList kind="quote" />} />
          <Route path="proformas/nueva" element={<DocEditor kind="quote" key="new-quote" />} />
          <Route path="proformas/:id/editar" element={<DocEditor kind="quote" key="edit-quote" />} />
          <Route path="proformas/:id" element={<DocView key="quote" kind="quote" />} />
          <Route path="facturas" element={<DocList kind="invoice" key="invoices" />} />
          <Route path="facturas/nueva" element={<DocEditor kind="invoice" key="new-invoice" />} />
          <Route path="facturas/:id" element={<DocView key="invoice" kind="invoice" />} />
          <Route path="cuentas-por-cobrar" element={<DocList kind="invoice" receivables key="cxc" />} />
          <Route path="reportes" element={<Reports />} />
          <Route path="configuracion" element={<Settings />} />
          <Route path="*" element={<Dashboard />} />
        </Route>
        <Route path="*" element={<PublicPage />} />
      </Routes>
      <Toaster richColors position="top-right" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
